import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader'
import MainFooter from '../../../components/MainFooter'

import './Diversity.css'
import './MDiversity.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'


export default function Diversity() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Diversity 🏳️‍🌈</title>
                <meta property="og:title" content="Diversity & Gender Disclaimer" />
                <meta property="og:description" content="Hier findest du unseren Gender Disclaimer und unsere Erklärung für Vielfalt und Inklusion" />
                <meta name="description" content="Hier findest du unseren Gender Disclaimer und unsere Erklärung für Vielfalt und Inklusion" />
            </Helmet>
            <section className='sec_next' id='sec_next--diversity'>
                <div className='sec_next_cont' id="sec_next--diversity--cont" style={{ wordBreak: "break-word", textAlign: "justify" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/rechtliches'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>

                    <h2>Diversity 🏳️‍🌈</h2>
                    <p>Die ToNetwork UG (haftungsbeschränkt) versteht sich als ein modernes, offenes und inklusives Unternehmen. Wir stehen ein für Diversität!</p>

                    <h3>1. Gleichbehandlung</h3>
                    <p>Selbstverständlich beziehen sich sämtliche Formulierungen auf unserer Website auf alle Menschen gleichermaßen – unabhängig von Geschlechtsidentität, sexueller Orientierung, ethnischer Herkunft, Religion oder Weltanschauung, Behinderung oder Alter. Wir bekennen uns klar zur Gleichbehandlung aller Menschen.</p>

                    <h3>2. Vielfalt als Teil unserer Unternehmenskultur</h3>
                    <p>Diversität ist für uns kein Trend, sondern ein zentraler Bestandteil unserer Unternehmenskultur. Unterschiedliche Perspektiven, Erfahrungen und Lebensläufe machen uns stärker, innovativer und menschlicher. Wir fördern aktiv ein inklusives Umfeld – intern wie extern – in dem jede Person Wertschätzung und Respekt erfährt.</p>

                    <h3>3. Inklusive Sprache</h3>
                    <p>Aus Gründen der besseren Lesbarkeit wird auf dieser Website bei Personenbezeichnungen und personenbezogenen Hauptwörtern entweder die männliche oder weibliche Form verwendet. Dies geschieht ausschließlich zur sprachlichen Vereinfachung und beinhaltet keinerlei Wertung. Wir bemühen uns unabhängig davon um eine inklusive, verständliche und respektvolle Sprache in all unseren Veröffentlichungen. Sollte uns dies an einer Stelle nicht gelungen sein, freuen wir uns über konstruktives Feedback. Gemeinsam lernen wir besser.</p>

                    <h3>4. Unser Versprechen</h3>
                    <p>Wir stehen für Offenheit, Respekt und Chancengleichheit. Unser Ziel ist es, mit tonetwork.de ein digitales Umfeld zu schaffen, das für alle Menschen zugänglich, verständlich und wertschätzend ist – ganz gleich, wer sie sind, wen sie lieben oder woher sie kommen.</p>

                    <h3>5. Kontakt</h3>
                    <p>Für Rückfragen, Anmerkungen oder Hinweise zu diesem Thema können Sie uns jederzeit kontaktieren:</p>
                    <p>
                        📧 E-Mail: <a href="mailto:info@tonetwork.de?subject=Diversity">info@tonetwork.de</a><br />
                        📞 Telefon: <a href='tel:+4983324908872'>+49 8332 4908872</a><br />
                        📬 Adresse: ToNetwork UG (h.), Im Moos 5, 87749 Hawangen
                    </p>
                    <h3>6. Stand dieser Erklärung</h3>
                    <p>Diese Erklärung wurde am 12.06.2025 erstellt.</p>
                </div>
            </section >

            <MainFooter />
        </div >
    )
}